<template>
  <v-app>
    <v-main class="pa-0">
       <slot> </slot>
    </v-main>
  </v-app>
</template>

<script>
export default {}
</script>
